module.exports = __webpack_public_path__ + "1708654020752/assets/img/banner2.cc225fe6.png";